module.exports = __webpack_public_path__ + "static/media/debt-consolidation-savings-estimate.c5452f5d.jpeg";